const belgianPostCodeRegex = /^(?:(?:[1-9])(?:\d{3}))$/

const isValidPostCode = (postCode: string): boolean => belgianPostCodeRegex.test(postCode)

export { isValidPostCode }
